module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a02/main_sp_50dacbd46935d52cb56ea106d60cc1cf.jpg";